@if( backButtonViewToggle$ | async) {
    <div class="back-button-wrapper">
        <span class="back-btn material-symbols-outlined" (click)="onBackButtonClick()">
            arrow_back_ios
        </span>
    </div>
}